<template>
    <div class="form-container">
        <div class="mb-3">
            <InputField
                :customErrorMessage="$t('form.fields.firstName.errorMessage')"
                :label="$t('form.fields.firstName.label')"
                :validationRules="validationRulesFirstName"
                name="firstName"
                ref="firstName"
            />
        </div>

        <div>
            <InputField
                :customErrorMessage="$t('form.fields.lastName.errorMessage')"
                :label="$t('form.fields.lastName.label')"
                :validationRules="validationRulesLastName"
                name="lastName"
            />
        </div>
    </div>
</template>

<script>
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'

export default {
    // static settings to initialize step (not reactive inside this file!)
    stepDefinition() {
        return {
            name: 'name',
            route: {
                relativeUrl: `name`,
                name: 'apply.name',
                meta: {
                    title: 'form.sections.aboutYou.name.heading',
                    tooltip: process.env.IS_VERVENT ? false : 'form.sections.aboutYou.name.tooltip',
                    tooltipType: 'small',
                    additionalInfoHeading: 'form.sections.aboutYou.name.additionalInfoHeading',
                    additionalInfo: 'form.sections.aboutYou.name.additionalInfo',
                    customTooltip: process.env.TERRITORY === 'usa',
                },
            },
            fields: {
                firstName: {
                    value: null,
                    mappedKey: 'first_name',
                    trimSpacers: true,
                    capitalize: true,
                    validationRules: {
                        stringMinWithoutSpace: true,
                        englishName: true,
                        required: true,
                        max: 50,
                        min: 2,
                    },
                },
                lastName: {
                    value: null,
                    mappedKey: 'last_name',
                    trimSpacers: true,
                    capitalize: true,
                    validationRules: {
                        stringMinWithoutSpace: true,
                        englishName: true,
                        required: true,
                        max: 100,
                        min: 2,
                    },
                },
            },
        }
    },

    setup() {
        const route = useRoute()
        const store = useStore()

        return {
            route,
            store,
        }
    },
    created() {
        this.emitter.emit('stepLoaded')
    },
    mounted() {
        this.autoFocus(this.$refs.firstName)
    },
    computed: {
        validationRulesFirstName: function () {
            return this.store.getters.fieldValidationRules('firstName')
        },
        validationRulesLastName: function () {
            return this.store.getters.fieldValidationRules('lastName')
        },
    },
}
</script>
